module.exports = __webpack_public_path__ + "img/Realisme_De_fire_store_Kielland.08866dba.jpg";